export default __webpack_public_path__ + "hashed/logo-NokianTyres.909b7c99.svg";